export const migrate_theme = {
  error_unknown: 'Quelque chose ne va pas',
  migrate_error: 'Erreur de migration',
  migrate_success: 'Migration réussie',
  migrating: 'Migration en cours',
} as const;
